var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"choice-chips"},[_c('div',{staticClass:"choice-chips__container"},_vm._l((_vm.computedOptions),function(option,index){return _c('button',{key:index,class:[
        'choice-chips__item',
        { 'choice-chips__item--active': _vm.isSelected(option) },
        { 'choice-chips__item--disabled': _vm.computedDisabled },
      ],attrs:{"type":"button","disabled":_vm.computedDisabled},on:{"click":function($event){return _vm.handleSelect(option)}}},[_vm._v(" "+_vm._s(_vm.getLabel(option))+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }